<template>
  <div class="table-overflow">
    <table class="table mb-0 table-striped" @click.stop="selectedObject = null;">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Segmento</th>
          <th scope="col" class="border-0 text-center">Ano</th>
          <th scope="col" class="border-0 text-center">Meta Semanal</th>
          <th scope="col" class="border-0 text-center">Metas Mensais</th>
          <th scope="col" class="border-0 text-center">Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in drives" :key="index" >
          <td class="td-1" @click.stop="selectedObject = row.id" >
            <span class="pl-2" v-if="selectedObject != row.id">{{ row.name || 'Segmento' }}</span>
            <d-input v-model="row.name" placeholder="Segmento" class="input-hidden" @change="capitalizeInput(index)" v-else/>
          </td>
          <td class="td-1 text-center" @click.stop="selectedObject = row.id">
            <span v-if="selectedObject != row.id">{{ row.goals[0].year }}</span>
            <d-input v-model="row.goals[0].year" placeholder="Ano" class="input-hidden text-right" v-else/>
          </td>
          <td class="td-1 text-center" @click.stop="selectedObject = row.id">
            <d-input-group prepend="R$">
              <input-currency
                :model="row"
                model-index="goal_weekly"
                placeholder="Meta Semanal"
              ></input-currency>
            </d-input-group>
          </td>
          <td class="td-1 text-center" @click.stop="selectedObject = row.id">
            <span class="ml-auto">
              <i class="mr-2 fas fa-edit" title="Editar Metas" @click="editGoals(row)"></i>
            </span>
          </td>
          <td class="td-1 text-right">
            <span class="ml-auto text-right text-semibold pr-3">
              <i class="mr-2 fas fa-plus text-success" @click="addRow()" v-if="index+1 == drives.length"></i>
              <i class="mr-2 fas fa-minus text-danger" @click="removeRow(row, index)"></i>
              <i class="fas fa-save" @click="saveQuotationDrives(row, index)"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <drive-goals-modal/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, capitalize, stringfy } from '_utils';
import CurrencyMask from '_common/mixins/CurrencyMask';
import QuotationService from '_services/rest/modules/quotation';
import InputCurrency from '_shared/InputCurrency.vue';
import { MONTHS, MODEL_DRIVE, _LOAD_DRIVE_GOAL_, _SAVE_DRIVE_GOAL_, MODEL_DRIVE_GOAL } from './SettingsModel';
import DriveGoalsModal from './DriveGoalsModal.vue';

export default {
  name: 'drives-form',
  mixins: [CurrencyMask],
  components: {
    DriveGoalsModal,
    InputCurrency,
  },
  data() {
    return {
      drives: [],
      loading: false,
      selectedObject: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    addRow() {
      this.drives.push(cloneDeep(MODEL_DRIVE));
    },
    capitalizeInput(index) {
      this.drives[index].name = capitalize(this.drives[index].name);
    },
    checkEmptyOptions(drives) {
      if (drives.length === 0) {
        drives.push(cloneDeep(MODEL_DRIVE));
      }
    },
    editGoals(drive) {
      Events.$emit(_LOAD_DRIVE_GOAL_, drive);
      this.setToggle({ type: 'edit_goal_modal', bool: true });
    },
    removeRow(drive, index) {
      this.drives.splice(index, 1);
      this.checkEmptyOptions(this.drives);
      QuotationService.deleteDrives(drive.id)
        .then(() => this.activeAlert({ message: 'Segmento deletado com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    getModelDriveGoal() {
      MODEL_DRIVE.goals = MONTHS.map(month => (
        { ...MODEL_DRIVE_GOAL, month }
      ));
    },
    getDrives() {
      QuotationService.getDrivesOptions()
        .then(response => {
          this.drives = response;
          this.checkEmptyOptions(this.drives);
        });
    },
    saveQuotationDrives(drive, index) {
      this.loading = true;
      drive.slug = stringfy(drive.name);
      drive.goals = this.setYearGoals(drive.goals);
      QuotationService.saveDrives(drive)
        .then(response => {
          this.drives[index] = response;
          this.selectedObject = null;
          this.activeAlert({ message: 'Segmento salvo com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    setYearGoals(goals) {
      return goals.map(goal => {
        goal.year = goals[0].year;
        return goal;
      });
    },
  },
  mounted() {
    this.getDrives();
    this.getModelDriveGoal();
    Events.$on(_SAVE_DRIVE_GOAL_, drive => {
      const index = this.drives.findIndex(row => row.id === drive.id);
      this.saveQuotationDrives(drive, index);
    });
  },
};
</script>

<style lang="scss" scoped>
.border-top {
  border-color:#3D5170;
}
table tr td {
  padding: .75rem .3rem;
}
.td-3 {
  width: 30%;
}
.td-2 {
  width: 7%;
  min-width: 120px;
}
.td-1 {
  width: 3%;
  min-width: 90px;
}
.input-hidden {
  width: 100%;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  height: 35px;
}
table td span {
  cursor: pointer;
}
</style>
